import { extendTheme } from 'native-base';
import { Button, FormControlErrorMessage, FormControlHelperText, FormControlLabel, FormControl, Input } from './components';
import Radio from './components/Radio';
import { colors } from './colors';
import { sizes } from './sizes';
import Checkbox from './components/CheckBox';
const components = {
  Button,
  FormControlLabel,
  FormControl,
  FormControlErrorMessage,
  FormControlHelperText,
  Input,
  Radio,
  Checkbox
};
export const fullAppTheme = extendTheme({
  sizes,
  colors,
  components
});
export { typography } from './fonts';
//# sourceMappingURL=index.js.map